import React, { Component } from 'react'
import { RollbackOutlined, SearchOutlined } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Select, Button, Input, DatePicker } from 'hljd'
import Styles from './style.module.less'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import store from '../store'

const Option = Select.Option
const RangePicker = DatePicker.RangePicker
const Item = Form.Item

@observer
export default class extends Component {
  state = {
    expand: false
  }

  render() {
    let {
      dataTime,
      form: { phone, status, name, order_no }
    } = store
    return (
      <div className={Styles['order-search']}>
        <Form layout="inline">
          <Item label="客户手机" style={{ marginBottom: 10 }}>
            <Input
              placeholder=""
              style={{ width: 130 }}
              value={phone}
              onChange={store.getPhone}
            />
          </Item>
          <Item label="客户姓名">
            <Input
              placeholder=""
              style={{ width: 143 }}
              value={name}
              onChange={store.getName}
            />
          </Item>
          <Item label="推荐号">
            <Input
              placeholder=""
              style={{ width: 143 }}
              value={order_no}
              onChange={store.getOrder}
            />
          </Item>
          <Item label="订单状态">
            <Select
              onChange={store.getStatus}
              value={status}
              style={{ width: 130 }}
            >
              <Option value="all">全部</Option>
              <Option value="0">未查看</Option>
              <Option value="1">已查看</Option>
              <Option value="2">已过期</Option>
              <Option value="4">跟进失败</Option>
              <Option value="5">定金已付</Option>
              <Option value="6">已退单</Option>
            </Select>
          </Item>
          <Item label="推荐时间">
            <RangePicker
              value={toJS(dataTime)}
              format="YYYY-MM-DD"
              onChange={store.getCreat}
            />
          </Item>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={store.searchFrom}
            style={{ marginRight: 10, marginLeft: 20 }}
          >
            查询
          </Button>
          <Button
            type="primary"
            onClick={store.searchRest}
            icon={<RollbackOutlined />}
          >
            重置
          </Button>
        </Form>
      </div>
    )
  }
}
